module.exports = __webpack_public_path__ + "img/laba-gonggao.e1cc3c3c.png";